// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__Cu52O","load2":"Spinner_load2__1c0_D"};